module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Selecione local de realização da prova")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "color": "amber darken-3",
      "items": _vm.locais,
      "label": "Local da Prova",
      "item-text": "descricao",
      "item-value": "ref_local_prova",
      "error-messages": _vm.validationMessageField(_vm.$v.form.ref_local_prova),
      "clearable": ""
    },
    on: {
      "change": _vm.localProvaAlterado,
      "input": function($event) {
        return _vm.$v.form.ref_local_prova.$touch()
      },
      "blur": function($event) {
        return _vm.$v.form.ref_local_prova.$touch()
      }
    },
    model: {
      value: (_vm.form.ref_local_prova),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref_local_prova", $$v)
      },
      expression: "form.ref_local_prova"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), (_vm.form.ref_local_prova) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Selecione quais cursos deseja se candidatar")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.opcoes), function(item, index) {
    return (_vm.form.ref_local_prova) ? _c('v-card', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pa-0"
    }, [_c('strong', [_vm._v(_vm._s(item.opcao) + "ª Opção de Curso")])])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "input-opcao pr-2",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "color": "amber darken-3",
        "items": _vm.campus,
        "label": "Campus",
        "item-text": "descricao",
        "item-value": "id",
        "error-messages": _vm.validationMessageField(_vm.$v.opcoes.$each[index].ref_campus),
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.selecionaCampus(item)
        },
        "input": function($event) {
          return _vm.$v.opcoes.$each[index].ref_campus.$touch()
        },
        "blur": function($event) {
          return _vm.$v.opcoes.$each[index].ref_campus.$touch()
        }
      },
      model: {
        value: (item.ref_campus),
        callback: function($$v) {
          _vm.$set(item, "ref_campus", $$v)
        },
        expression: "item.ref_campus"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "input-opcao",
      attrs: {
        "xs12": "",
        "sm8": ""
      }
    }, [_c('v-autocomplete', {
      attrs: {
        "color": "amber darken-3",
        "disabled": !item.ref_campus,
        "items": item.cursos,
        "label": "Cursos",
        "item-text": "curso",
        "item-value": "ref_oferta_curriculo",
        "error-messages": _vm.validationMessageField(_vm.$v.opcoes.$each[index].ref_oferta_curriculo),
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.selecionaOpcao(item)
        },
        "input": function($event) {
          return _vm.$v.opcoes.$each[index].ref_oferta_curriculo.$touch()
        },
        "blur": function($event) {
          return _vm.$v.opcoes.$each[index].ref_oferta_curriculo.$touch()
        }
      },
      model: {
        value: (item.ref_oferta_curriculo),
        callback: function($$v) {
          _vm.$set(item, "ref_oferta_curriculo", $$v)
        },
        expression: "item.ref_oferta_curriculo"
      }
    })], 1)], 1), _vm._v(" "), (item.ref_oferta_curriculo) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      staticClass: "box-informacoes ma-1"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pa-0 pl-2 title-informacoes"
    }, [_vm._v("\n                                        Informaçoes do curso\n                                        " + _vm._s(_vm.buscarCurso(item.ref_oferta_curriculo).curso) + "\n                                    ")])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "pb-3 pl-2",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Carga Horária:")]), _vm._v(" "), _c('span', {
      staticClass: "informacao"
    }, [_vm._v("\n                                        " + _vm._s(_vm.buscarCurso(item.ref_oferta_curriculo).carga_horaria_min) + " Horas\n                                    ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pb-3 pl-2",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Turno:")]), _vm._v(" "), _c('span', {
      staticClass: "informacao"
    }, [_vm._v("\n                                        " + _vm._s(_vm.buscarCurso(item.ref_oferta_curriculo).turno) + "\n                                    ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pb-3 pl-2",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Duração:")]), _vm._v(" "), _c('span', {
      staticClass: "informacao"
    }, [_vm._v("\n                                        " + _vm._s(_vm.buscarCurso(item.ref_oferta_curriculo).total_semestres) + " Semestres\n                                    ")])]), _vm._v(" "), _c('v-flex', {
      staticClass: "ma-1",
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v("Mais Informações clique aqui")])])], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4f6a43e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/vestibular/components/etapas/SelecaoCursos.vue
// module id = 581
// module chunks = 2